import { getFeatureFlag, isString, isBoolean } from "@sinch/feature-flags";
import { hotjar } from "react-hotjar";

export const initHotjar = () => {
  const enableHotjar = getFeatureFlag("enablehotjar", isBoolean, false);
  const id = getFeatureFlag("hotjarkey", isString, "");
  if (!enableHotjar || !id) {
    return Promise.resolve();
  }
  hotjar.initialize({
    id: Number(id),
    sv: 6,
  });
  return Promise.resolve();
};
